import React from 'react';
import Button from '../../../../shared/button';


interface ISuccessfullyGeneratedLocations {
    handleCloseModal: () => void;
}

const SuccessfullyGeneratedLocations = ({
    handleCloseModal
}: ISuccessfullyGeneratedLocations) => {
    return (
        <div className={'w-full flex flex-col items-center justify-between'}>
            <div>
                <p className='text-md font-medium text-center'>The creation of locations for the selected section and its configurations is currently underway. Upon completion, you may review them in the Generated Locations tab.</p>
            </div>
            <img src={'/assets/shared/loading-sand.svg'} className={'h-[100px] object-contain my-10'} />
            <Button
                label='Close'
                dataQa={'close-button'}
                className='btn-primary-rounded-less my-3 min-w-[150px] !shadow-none'
                onClickButton={handleCloseModal}
            />
        </div>
    )
}

export default SuccessfullyGeneratedLocations;